import '../styles/UserProfileCard.css';
import { arrowTopIcon, wrenchIcon } from '../utils/svgs';
import IssuesTableModal from "./modals/IssuesTableModal";
import UserAvatar from "./UserAvatar";

const UserProfileCard = ({ row, showModal, setShowModal, handleCardMouseEnter, handleCardMouseLeave, closeHoverCard }) => {

    const handleViewAllTask = () => {
        setShowModal(true);
    };

    const onCloseModal = () => {
        handleCardMouseEnter()
        handleCardMouseLeave()
        closeHoverCard()
        setShowModal(false);
    }

    return (
        <div className='user_profile_card'>
            <div>
                <UserAvatar username={row?.username} image={row?.image} size={60} fontSize="22px" />
                <div className='user_profile_details'>
                    <h3>{row?.username}</h3>
                    <p>{row?.my_role?.name}</p>

                    <div className="mt-2">
                        <ul>
                            {
                                row?.group_permissions?.map((perm, idx) => (
                                    <li key={idx}>{perm.name}</li>
                                ))
                            }
                        </ul>
                    </div>
                </div>
            </div>
            <div className='user_services'>
                {
                    row?.all_issue?.map((issue, idx) => (
                        <div key={idx} style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                            {wrenchIcon}
                            <p
                                style={{
                                    maxWidth: '110px',
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    margin: 0
                                }}
                                title={issue.summery}
                            >
                                {issue.summery}
                            </p>
                            {arrowTopIcon}
                        </div>
                    ))
                }
            </div>
            <div className='user_profile_footer'>
                <button onClick={handleViewAllTask}>View All Task</button>
            </div>
            <IssuesTableModal
                show={showModal}
                onHide={onCloseModal}
                userId={row?.id}
                username={row?.username}
            />
        </div>
    )
}

export default UserProfileCard